<div class="py-[30px] px-[50px]">
  <div class="text-center">
    <img src="/assets/v4/icon-connect-success.svg" class="w-[100px]" alt="" />
    <ng-container *ngIf="thirdpartyType === Platform.Booking; else others">
      <div class="text-xxl mt-[30px]">
        {{ "channel-connect_success_html_请求已发送" | translate }}
        <!-- Your connection request is successfully sent! -->
      </div>
      <div class="text-l mt-6">
        {{ "channel-connect_success_html_请求已发送说明" | translate }}
        <!-- Your connection request will usually be processed within a few minutes, so keep an eye on the connection status
        in the Connected accounts list. -->
      </div>
    </ng-container>
    <ng-template #others>
      <div class="text-xxl mt-[30px]">
        {{ "channel-connect_success_html_成功关联" | translate }}
        <!-- You have successfully connected! -->
      </div>
    </ng-template>
  </div>

  <div class="mt-[30px]">
    <v4-widget-card
      [title]="'channel-connect_success_html_关联标题' | translate"
      [content]="'channel-connect_success_html_关联说明' | translate">
      <div class="card_button">
        <a routerLink="/app/connected-accounts/listing-linking">
          <button nz-button nzSize="large" nzType="primary">
            {{ "channel-connect_success_html_开始" | translate }}
            <!-- Get started -->
          </button>
        </a>
      </div>
    </v4-widget-card>
  </div>

  @if (showDocLink) {
    <div class="mt-[30px]">
      <v4-widget-card
        [title]="
          'channel-connect_success_html_学习更多标题'
            | translate: { channel: 'word.channel_' + thirdpartyType | translate }
        "
        [content]="'channel-connect_success_html_学习更多说明' | translate">
        <div class="card_button">
          <a [href]="docLink">
            <button nz-button nzSize="large">
              {{ "channel-connect_success_html_开始" | translate }}
              <!-- Get started -->
            </button>
          </a>
        </div>
      </v4-widget-card>
    </div>
  }

  <div class="mt-[30px] text-center">
    <button nz-button nzType="primary" nzSize="large" (click)="onClose()">
      {{ "channel-connect_success_html_完成" | translate }}
      <!-- Finish -->
    </button>
  </div>
</div>
